import React, { useEffect, useMemo, useState } from 'react';
import Cep from 'react-simple-cep-mask';
import CpfCnpj from '@react-br-forms/cpf-cnpj-mask';
import cep from 'cep-promise';
import { db } from '../../../database/firebase';
import { collection, addDoc } from 'firebase/firestore';
import TelefoneBrasileiroInput from 'react-telefone-brasileiro';
import { motion, AnimatePresence } from 'framer-motion';
import {
    FiAlertCircle,
    FiCheckCircle,
    FiFileText,
    FiMapPin,
    FiPhone,
    FiBriefcase,
    FiHome,
    FiMail,
} from 'react-icons/fi';

function FornecedorForm() {
    const [razaoSocial, setRazaoSocial] = useState('');
    const [cnpj, setCnpj] = useState('');
    const [email, setEmail] = useState('');
    const [telephone, setTelephone] = useState('');
    const [atuationArea, setAtuationArea] = useState('Engenharia Civil');
    const [cepresult, setCep] = useState('');
    const [endereco, setEndereco] = useState('');
    const [bairro, setBairro] = useState('');
    const [residenceNunber, setResidenceNuber] = useState('');
    const [cidade, setCidade] = useState('');
    const [endereComplement, setEnderecoComplement] = useState('');
    const [coutry] = useState('Brazil');
    const [category, setCategory] = useState('');
    const [messageError, setError] = useState('');
    const [resultTrue, setResultTrue] = useState('');
    const [checked, setChecked] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [touched, setTouched] = useState({});

    const [category2, setCategory2] = useState({
        auditoriaCheck: false,
        beneficiosCheck: false,
        epiCheck: false,
        facilitiesCheck: false,
        informaticaCheck: false,
        infraestruturaCheck: false,
        materialGraficoCheck: false,
        materialEscritorioCheck: false,
        materialEletricoCheck: false,
        ObrasConversacaoCheck: false,
        ObrasSinalizacaoCheck: false,
        pecasCheck: false,
        produtosAsfalticosCheck: false,
        servicosManuntecaoCheck: false,
        servicosOperacoesCheck: false,
        TecnologiaAutomacaoCheck: false,
        tintasCheck: false,
        TransportePassageirosCheck: false,
        TransporteValoresCheck: false,
        outroCheck: false,
    });

    const secondLevelOptions = useMemo(
        () => [
            { key: 'auditoriaCheck', label: 'Auditoria / Consultorias' },
            { key: 'beneficiosCheck', label: 'Benefícios' },
            { key: 'epiCheck', label: 'EPI / Uniformes' },
            { key: 'facilitiesCheck', label: 'Facilities' },
            { key: 'informaticaCheck', label: 'Informática / Eletrônicos' },
            { key: 'infraestruturaCheck', label: 'Infraestrutura - Instalações' },
            { key: 'materialGraficoCheck', label: 'Material gráfico' },
            { key: 'materialEscritorioCheck', label: 'Material de escritório / higiene / limpeza' },
            { key: 'materialEletricoCheck', label: 'Material elétrico' },
            { key: 'ObrasConversacaoCheck', label: 'Obras - Conservação especial / Meio ambiente' },
            { key: 'ObrasSinalizacaoCheck', label: 'Obras - Sinalização / Elementos de segurança' },
            { key: 'pecasCheck', label: 'Peças / Equipamentos' },
            { key: 'produtosAsfalticosCheck', label: 'Produtos asfálticos - Material' },
            { key: 'servicosManuntecaoCheck', label: 'Serviços de manutenção' },
            { key: 'servicosOperacoesCheck', label: 'Serviços de operações' },
            { key: 'TecnologiaAutomacaoCheck', label: 'Tecnologia - Automação / Elétrica / Infraestrutura / Sistemas' },
            { key: 'tintasCheck', label: 'Tintas viárias / Placas / Tachas' },
            { key: 'TransportePassageirosCheck', label: 'Transporte de passageiros' },
            { key: 'TransporteValoresCheck', label: 'Transporte de valores' },
            { key: 'outroCheck', label: 'Outros' },
        ],
        []
    );

    useEffect(() => {
        const cleanCep = String(cepresult).replace(/\D/g, '');
        if (cleanCep.length !== 8) return;

        cep(cleanCep)
            .then((result) => {
                setEndereco(result.street || '');
                setCidade(result.city || '');
                setBairro(result.neighborhood || '');
            })
            .catch(() => {
                setEndereco('');
                setCidade('');
                setBairro('');
            });
    }, [cepresult]);

    function handlerTimeout(state, count) {
        setTimeout(() => {
            state('');
        }, count);
    }

    function markTouched(fieldName) {
        setTouched((prev) => ({ ...prev, [fieldName]: true }));
    }

    function normalizeDigits(value = '') {
        return String(value).replace(/\D/g, '');
    }

    function handleSecondLevelChange(key) {
        setCategory2((prev) => ({
            ...prev,
            [key]: !prev[key],
        }));
    }

    const hasAtLeastOneSecondLevel = Object.values(category2).some(Boolean);

    const validation = {
        razaoSocial: razaoSocial.trim().length >= 3,
        cnpj: normalizeDigits(cnpj).length === 14,
        email: /\S+@\S+\.\S+/.test(email),
        telephone: normalizeDigits(telephone).length >= 10,
        cepresult: normalizeDigits(cepresult).length === 8,
        endereco: endereco.trim().length >= 3,
        bairro: bairro.trim().length >= 2,
        residenceNunber: residenceNunber.trim().length >= 1,
        cidade: cidade.trim().length >= 2,
        category: !!category,
        category2: hasAtLeastOneSecondLevel,
        checked: checked,
    };

    function getFieldState(fieldName) {
        if (!touched[fieldName]) return {};
        const isValid = validation[fieldName];
        return {
            border: `1px solid ${isValid ? 'rgba(25, 135, 84, 0.45)' : 'rgba(220, 53, 69, 0.45)'}`,
            boxShadow: isValid
                ? '0 0 0 0.2rem rgba(25, 135, 84, 0.08)'
                : '0 0 0 0.2rem rgba(220, 53, 69, 0.08)',
        };
    }

    function validateBeforeSubmit() {
        setTouched({
            razaoSocial: true,
            cnpj: true,
            email: true,
            telephone: true,
            cepresult: true,
            endereco: true,
            bairro: true,
            residenceNunber: true,
            cidade: true,
            category: true,
            category2: true,
            checked: true,
        });

        if (!validation.razaoSocial) return 'Por favor, informe a razão social.';
        if (!validation.cnpj) return 'Informe um CNPJ válido.';
        if (!validation.email) return 'Informe um e-mail válido.';
        if (!validation.telephone) return 'Informe um telefone válido.';
        if (!validation.cepresult) return 'Informe um CEP válido.';
        if (!validation.endereco) return 'Não foi possível identificar o endereço a partir do CEP.';
        if (!validation.bairro) return 'Não foi possível identificar o bairro a partir do CEP.';
        if (!validation.residenceNunber) return 'É necessário preencher o número do endereço.';
        if (!validation.cidade) return 'Não foi possível identificar a cidade a partir do CEP.';
        if (!validation.category) return 'É necessário selecionar uma categoria de fornecimento de 1º nível.';
        if (!validation.category2) return 'Selecione pelo menos uma categoria de fornecimento de 2º nível.';
        if (!validation.checked) return 'Você precisa concordar com os termos e a política de privacidade.';
        return '';
    }

    function resetForm() {
        setRazaoSocial('');
        setCnpj('');
        setEmail('');
        setTelephone('');
        setAtuationArea('Engenharia Civil');
        setCep('');
        setEndereco('');
        setBairro('');
        setResidenceNuber('');
        setCidade('');
        setEnderecoComplement('');
        setCategory('');
        setChecked(false);
        setTouched({});
        setCategory2({
            auditoriaCheck: false,
            beneficiosCheck: false,
            epiCheck: false,
            facilitiesCheck: false,
            informaticaCheck: false,
            infraestruturaCheck: false,
            materialGraficoCheck: false,
            materialEscritorioCheck: false,
            materialEletricoCheck: false,
            ObrasConversacaoCheck: false,
            ObrasSinalizacaoCheck: false,
            pecasCheck: false,
            produtosAsfalticosCheck: false,
            servicosManuntecaoCheck: false,
            servicosOperacoesCheck: false,
            TecnologiaAutomacaoCheck: false,
            tintasCheck: false,
            TransportePassageirosCheck: false,
            TransporteValoresCheck: false,
            outroCheck: false,
        });
    }

    async function handlerSendForm(e) {
        e.preventDefault();
        setError('');
        setResultTrue('');

        const validationError = validateBeforeSubmit();
        if (validationError) {
            setError(validationError);
            handlerTimeout(setError, 6000);
            return;
        }

        setIsSubmitting(true);

        try {
            await addDoc(collection(db, 'suppliers'), {
                razaoSocial,
                cnpj,
                email,
                telefone: telephone,
                AreaAtuacao: atuationArea,
                cep: cepresult,
                endereco,
                bairro,
                numero: residenceNunber,
                cidade,
                complemento: endereComplement,
                pais: coutry,
                data: new Date().toLocaleDateString('pt-BR'),
                category,
                category2,
            });

            setResultTrue('Seu pré-cadastro foi efetuado com sucesso!');
            resetForm();
            handlerTimeout(setResultTrue, 7000);
        } catch (error) {
            console.log(error);
            setError('Não foi possível concluir o cadastro no momento. Tente novamente.');
            handlerTimeout(setError, 6000);
        } finally {
            setIsSubmitting(false);
        }
    }

    const inputBaseStyle = {
        borderRadius: '14px',
        minHeight: '52px',
        background: '#ffffff',
        border: '1px solid rgba(13, 46, 99, 0.10)',
        padding: '12px 14px',
        color: '#10213a',
        transition: 'all 0.25s ease',
    };

    const labelStyle = {
        fontWeight: 700,
        fontSize: '0.94rem',
        color: '#0d2e63',
        marginBottom: '10px',
        display: 'block',
    };

    const sideCardStyle = {
        background: '#ffffff',
        borderRadius: '24px',
        padding: '24px',
        boxShadow: '0 18px 48px rgba(15, 23, 42, 0.07)',
        border: '1px solid rgba(13, 46, 99, 0.06)',
    };

    return (
        <section style={{ padding: '0' }} id="form7-1k">
            <div className="container">
                <form onSubmit={handlerSendForm}>
                    <div className="row g-4 align-items-start">
                        <div className="col-lg-8">
                            <div
                                style={{
                                    background: '#ffffff',
                                    borderRadius: '24px',
                                    padding: '26px',
                                    boxShadow: '0 18px 48px rgba(15, 23, 42, 0.07)',
                                    border: '1px solid rgba(13, 46, 99, 0.06)',
                                }}
                            >
                                <div className="row g-4">
                                    <div className="col-12">
                                        <div
                                            style={{
                                                fontSize: '1.05rem',
                                                fontWeight: 800,
                                                color: '#0d2e63',
                                                marginBottom: '4px',
                                            }}
                                        >
                                            Informações da empresa
                                        </div>
                                        <div style={{ color: '#607089', lineHeight: 1.7 }}>
                                            Preencha os dados principais do fornecedor para iniciar o pré-cadastro junto à RealEnergy.
                                        </div>
                                    </div>

                                    <div className="col-md-6">
                                        <label style={labelStyle}>Razão social</label>
                                        <div style={{ position: 'relative' }}>
                                            <FiHome
                                                size={18}
                                                style={{
                                                    position: 'absolute',
                                                    left: '14px',
                                                    top: '17px',
                                                    color: '#68809f',
                                                    zIndex: 2,
                                                }}
                                            />
                                            <input
                                                type="text"
                                                placeholder="Razão social"
                                                className="form-control"
                                                value={razaoSocial}
                                                onChange={(e) => setRazaoSocial(e.target.value)}
                                                onBlur={() => markTouched('razaoSocial')}
                                                style={{
                                                    ...inputBaseStyle,
                                                    ...getFieldState('razaoSocial'),
                                                    paddingLeft: '42px',
                                                }}
                                            />
                                        </div>
                                    </div>

                                    <div className="col-md-6">
                                        <label style={labelStyle}>CNPJ</label>
                                        <CpfCnpj
                                            value={cnpj}
                                            onChange={(event) => setCnpj(event.target.value)}
                                            onBlur={() => markTouched('cnpj')}
                                            className="form-control"
                                            maxLength="19"
                                            placeholder="00.000.000/0001-00"
                                            style={{ ...inputBaseStyle, ...getFieldState('cnpj') }}
                                        />
                                    </div>

                                    <div className="col-md-6">
                                        <label style={labelStyle}>E-mail</label>
                                        <div style={{ position: 'relative' }}>
                                            <FiMail
                                                size={18}
                                                style={{
                                                    position: 'absolute',
                                                    left: '14px',
                                                    top: '17px',
                                                    color: '#68809f',
                                                    zIndex: 2,
                                                }}
                                            />
                                            <input
                                                type="email"
                                                placeholder="Email"
                                                className="form-control"
                                                value={email}
                                                onChange={(e) => setEmail(e.target.value)}
                                                onBlur={() => markTouched('email')}
                                                style={{
                                                    ...inputBaseStyle,
                                                    ...getFieldState('email'),
                                                    paddingLeft: '42px',
                                                }}
                                            />
                                        </div>
                                    </div>

                                    <div className="col-md-6">
                                        <label style={labelStyle}>Telefone</label>
                                        <div style={{ position: 'relative' }}>
                                            <FiPhone
                                                size={18}
                                                style={{
                                                    position: 'absolute',
                                                    left: '14px',
                                                    top: '17px',
                                                    color: '#68809f',
                                                    zIndex: 2,
                                                }}
                                            />
                                            <TelefoneBrasileiroInput
                                                value={telephone}
                                                onChange={(event) => setTelephone(event.target.value)}
                                                onBlur={() => markTouched('telephone')}
                                                temDDD
                                                separaNono
                                                className="form-control"
                                                placeholder="(81) 90000-0000"
                                                style={{
                                                    ...inputBaseStyle,
                                                    ...getFieldState('telephone'),
                                                    paddingLeft: '42px',
                                                }}
                                            />
                                        </div>
                                    </div>

                                    <div className="col-12">
                                        <label style={labelStyle}>Área de atuação</label>
                                        <div style={{ position: 'relative' }}>
                                            <FiBriefcase
                                                size={18}
                                                style={{
                                                    position: 'absolute',
                                                    left: '14px',
                                                    top: '17px',
                                                    color: '#68809f',
                                                    zIndex: 2,
                                                }}
                                            />
                                            <select
                                                className="form-select"
                                                value={atuationArea}
                                                onChange={(e) => setAtuationArea(e.target.value)}
                                                style={{ ...inputBaseStyle, paddingLeft: '42px' }}
                                            >
                                                <option value="Engenharia Civil">Engenharia Civil</option>
                                                <option value="Engenharia Mecânica">Engenharia Mecânica</option>
                                                <option value="Engenharia Elétrica">Engenharia Elétrica</option>
                                                <option value="Engenharia Automação">Engenharia Automação</option>
                                                <option value="Engenharia Eletrônica">Engenharia Eletrônica</option>
                                                <option value="Outros">Outros</option>
                                            </select>
                                        </div>
                                    </div>

                                    <div className="col-12" style={{ marginTop: '8px' }}>
                                        <div
                                            style={{
                                                fontSize: '1.05rem',
                                                fontWeight: 800,
                                                color: '#0d2e63',
                                                marginBottom: '4px',
                                            }}
                                        >
                                            Endereço
                                        </div>
                                        <div style={{ color: '#607089', lineHeight: 1.7 }}>
                                            Informe o CEP para preenchimento automático do endereço.
                                        </div>
                                    </div>

                                    <div className="col-md-4">
                                        <label style={labelStyle}>CEP</label>
                                        <Cep
                                            value={cepresult}
                                            onChange={(value) => setCep(value)}
                                            onBlur={() => markTouched('cepresult')}
                                            className="form-control"
                                            placeholder="Digite o CEP"
                                            style={{ ...inputBaseStyle, ...getFieldState('cepresult') }}
                                        />
                                    </div>

                                    <div className="col-md-8">
                                        <label style={labelStyle}>Endereço</label>
                                        <div style={{ position: 'relative' }}>
                                            <FiMapPin
                                                size={18}
                                                style={{
                                                    position: 'absolute',
                                                    left: '14px',
                                                    top: '17px',
                                                    color: '#68809f',
                                                    zIndex: 2,
                                                }}
                                            />
                                            <input
                                                type="text"
                                                className="form-control"
                                                value={endereco}
                                                disabled
                                                placeholder="Endereço"
                                                onBlur={() => markTouched('endereco')}
                                                style={{
                                                    ...inputBaseStyle,
                                                    ...getFieldState('endereco'),
                                                    paddingLeft: '42px',
                                                    background: '#f8fbff',
                                                }}
                                            />
                                        </div>
                                    </div>

                                    <div className="col-md-4">
                                        <label style={labelStyle}>Bairro</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            value={bairro}
                                            disabled
                                            placeholder="Bairro"
                                            onBlur={() => markTouched('bairro')}
                                            style={{
                                                ...inputBaseStyle,
                                                ...getFieldState('bairro'),
                                                background: '#f8fbff',
                                            }}
                                        />
                                    </div>

                                    <div className="col-md-4">
                                        <label style={labelStyle}>Número</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            value={residenceNunber}
                                            onChange={(e) => setResidenceNuber(e.target.value)}
                                            onBlur={() => markTouched('residenceNunber')}
                                            placeholder="Número"
                                            style={{ ...inputBaseStyle, ...getFieldState('residenceNunber') }}
                                        />
                                    </div>

                                    <div className="col-md-4">
                                        <label style={labelStyle}>Cidade</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            value={cidade}
                                            disabled
                                            placeholder="Cidade"
                                            onBlur={() => markTouched('cidade')}
                                            style={{
                                                ...inputBaseStyle,
                                                ...getFieldState('cidade'),
                                                background: '#f8fbff',
                                            }}
                                        />
                                    </div>

                                    <div className="col-md-6">
                                        <label style={labelStyle}>Complemento</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            value={endereComplement}
                                            onChange={(e) => setEnderecoComplement(e.target.value)}
                                            placeholder="Complemento"
                                            style={inputBaseStyle}
                                        />
                                    </div>

                                    <div className="col-md-6">
                                        <label style={labelStyle}>País</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            value={coutry}
                                            disabled
                                            style={{ ...inputBaseStyle, background: '#f8fbff' }}
                                        />
                                    </div>

                                    <div className="col-12" style={{ marginTop: '8px' }}>
                                        <div
                                            style={{
                                                fontSize: '1.05rem',
                                                fontWeight: 800,
                                                color: '#0d2e63',
                                                marginBottom: '4px',
                                            }}
                                        >
                                            Classificação do fornecedor
                                        </div>
                                        <div style={{ color: '#607089', lineHeight: 1.7 }}>
                                            Selecione a categoria de fornecimento e ao menos uma especialidade de 2º nível.
                                        </div>
                                    </div>

                                    <div className="col-12">
                                        <label style={labelStyle}>Categoria de fornecimento – 1º nível</label>
                                        <div
                                            style={{
                                                display: 'flex',
                                                gap: '18px',
                                                flexWrap: 'wrap',
                                                ...getFieldState('category'),
                                                borderRadius: '14px',
                                                padding: '8px 2px',
                                            }}
                                        >
                                            {['Serviços', 'Materiais', 'Materiais e Serviços'].map((item) => (
                                                <label
                                                    key={item}
                                                    style={{
                                                        display: 'inline-flex',
                                                        alignItems: 'center',
                                                        gap: '10px',
                                                        color: '#4f617a',
                                                        fontWeight: 600,
                                                    }}
                                                >
                                                    <input
                                                        type="radio"
                                                        name="category"
                                                        value={item}
                                                        checked={category === item}
                                                        onChange={(e) => {
                                                            setCategory(e.target.value);
                                                            markTouched('category');
                                                        }}
                                                    />
                                                    {item}
                                                </label>
                                            ))}
                                        </div>
                                    </div>

                                    <div className="col-12">
                                        <label style={labelStyle}>Categoria de fornecimento – 2º nível</label>
                                        <div
                                            style={{
                                                background: '#f8fbff',
                                                borderRadius: '18px',
                                                padding: '18px',
                                                border: touched.category2 && !validation.category2
                                                    ? '1px solid rgba(220, 53, 69, 0.25)'
                                                    : '1px solid rgba(13, 46, 99, 0.06)',
                                            }}
                                        >
                                            <div className="row g-3">
                                                {secondLevelOptions.map((item) => (
                                                    <div className="col-md-6" key={item.key}>
                                                        <label
                                                            style={{
                                                                display: 'flex',
                                                                alignItems: 'flex-start',
                                                                gap: '10px',
                                                                color: '#4f617a',
                                                                lineHeight: 1.6,
                                                                cursor: 'pointer',
                                                                fontWeight: 500,
                                                            }}
                                                        >
                                                            <input
                                                                type="checkbox"
                                                                checked={category2[item.key]}
                                                                onChange={() => {
                                                                    handleSecondLevelChange(item.key);
                                                                    markTouched('category2');
                                                                }}
                                                                style={{ marginTop: '4px' }}
                                                            />
                                                            <span>{item.label}</span>
                                                        </label>
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="col-lg-4">
                            <div style={{ ...sideCardStyle, marginBottom: '24px' }}>
                                <div
                                    style={{
                                        fontSize: '1.05rem',
                                        fontWeight: 800,
                                        color: '#0d2e63',
                                        marginBottom: '10px',
                                    }}
                                >
                                    Orientações
                                </div>

                                <div style={{ display: 'grid', gap: '14px' }}>
                                    <div style={{ display: 'flex', gap: '10px', color: '#607089', lineHeight: 1.7 }}>
                                        <FiFileText size={18} style={{ marginTop: '4px', flexShrink: 0 }} />
                                        <span>Preencha os dados da empresa com clareza e atenção.</span>
                                    </div>
                                    <div style={{ display: 'flex', gap: '10px', color: '#607089', lineHeight: 1.7 }}>
                                        <FiMapPin size={18} style={{ marginTop: '4px', flexShrink: 0 }} />
                                        <span>Informe corretamente o CEP para facilitar o preenchimento automático do endereço.</span>
                                    </div>
                                    <div style={{ display: 'flex', gap: '10px', color: '#607089', lineHeight: 1.7 }}>
                                        <FiBriefcase size={18} style={{ marginTop: '4px', flexShrink: 0 }} />
                                        <span>Selecione categorias compatíveis com os produtos e serviços da empresa.</span>
                                    </div>
                                </div>
                            </div>

                            <div style={{ ...sideCardStyle, marginBottom: '24px' }}>
                                <div
                                    style={{
                                        fontSize: '1.05rem',
                                        fontWeight: 800,
                                        color: '#0d2e63',
                                        marginBottom: '10px',
                                    }}
                                >
                                    Verificações
                                </div>

                                <div style={{ display: 'grid', gap: '12px' }}>
                                    {[
                                        { label: 'Razão social preenchida', valid: validation.razaoSocial },
                                        { label: 'CNPJ válido', valid: validation.cnpj },
                                        { label: 'E-mail válido', valid: validation.email },
                                        { label: 'Telefone válido', valid: validation.telephone },
                                        { label: 'CEP preenchido', valid: validation.cepresult },
                                        { label: 'Categoria de 1º nível', valid: validation.category },
                                        { label: 'Categoria de 2º nível', valid: validation.category2 },
                                        { label: 'Termos aceitos', valid: validation.checked },
                                    ].map((item) => (
                                        <div
                                            key={item.label}
                                            style={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                gap: '10px',
                                                color: item.valid ? '#198754' : '#607089',
                                                fontWeight: 600,
                                            }}
                                        >
                                            {item.valid ? (
                                                <FiCheckCircle size={18} />
                                            ) : (
                                                <FiAlertCircle size={18} />
                                            )}
                                            <span>{item.label}</span>
                                        </div>
                                    ))}
                                </div>
                            </div>

                            <div style={sideCardStyle}>
                                <div
                                    style={{
                                        fontSize: '1.05rem',
                                        fontWeight: 800,
                                        color: '#0d2e63',
                                        marginBottom: '10px',
                                    }}
                                >
                                    Confirmação legal
                                </div>

                                <label
                                    style={{
                                        display: 'flex',
                                        alignItems: 'flex-start',
                                        gap: '12px',
                                        color: '#4f617a',
                                        lineHeight: 1.7,
                                        cursor: 'pointer',
                                    }}
                                >
                                    <input
                                        type="checkbox"
                                        checked={checked}
                                        onChange={() => {
                                            setChecked(!checked);
                                            markTouched('checked');
                                        }}
                                        style={{ marginTop: '5px' }}
                                    />
                                    <span>
                                        Eu concordo com os termos de serviço e com a{' '}
                                        <a
                                            style={{
                                                color: '#0d4fb3',
                                                textDecoration: 'none',
                                                fontWeight: 700,
                                            }}
                                            href="/etica"
                                        >
                                            Política de Privacidade
                                        </a>
                                        .
                                    </span>
                                </label>
                            </div>
                        </div>
                    </div>

                    <div
                        style={{
                            marginTop: '28px',
                            background: '#ffffff',
                            borderRadius: '24px',
                            padding: '24px',
                            boxShadow: '0 18px 48px rgba(15, 23, 42, 0.07)',
                            border: '1px solid rgba(13, 46, 99, 0.06)',
                        }}
                    >
                        <div className="row align-items-center g-3">
                            <div className="col-lg-8">
                                <div
                                    style={{
                                        fontSize: '1.05rem',
                                        fontWeight: 800,
                                        color: '#0d2e63',
                                        marginBottom: '6px',
                                    }}
                                >
                                    Finalizar pré-cadastro
                                </div>
                                <div style={{ color: '#607089', lineHeight: 1.8 }}>
                                    Revise as informações prestadas e clique abaixo para enviar o cadastro da sua empresa.
                                </div>
                            </div>

                            <div className="col-lg-4 text-lg-end">
                                <motion.button
                                    type="submit"
                                    whileHover={{ y: -2, scale: 1.01 }}
                                    whileTap={{ scale: 0.98 }}
                                    disabled={isSubmitting}
                                    style={{
                                        width: '100%',
                                        maxWidth: '320px',
                                        minHeight: '56px',
                                        border: 'none',
                                        borderRadius: '14px',
                                        background: isSubmitting
                                            ? 'linear-gradient(135deg, #86a8dc, #5e8dd6)'
                                            : 'linear-gradient(135deg, #0d4fb3, #0a3d91)',
                                        color: '#ffffff',
                                        fontWeight: 800,
                                        boxShadow: '0 18px 36px rgba(13, 79, 179, 0.22)',
                                        transition: 'all 0.25s ease',
                                    }}
                                >
                                    {isSubmitting ? 'Enviando cadastro...' : 'Enviar cadastro'}
                                </motion.button>
                            </div>
                        </div>
                    </div>

                    <AnimatePresence>
                        {messageError && (
                            <motion.div
                                initial={{ opacity: 0, y: 12 }}
                                animate={{ opacity: 1, y: 0 }}
                                exit={{ opacity: 0, y: 12 }}
                                transition={{ duration: 0.22 }}
                                style={{
                                    marginTop: '22px',
                                    borderRadius: '18px',
                                    padding: '16px 18px',
                                    background: '#fff5f5',
                                    border: '1px solid rgba(220, 53, 69, 0.15)',
                                    color: '#b02a37',
                                    fontWeight: 600,
                                }}
                            >
                                {messageError}
                            </motion.div>
                        )}
                    </AnimatePresence>

                    <AnimatePresence>
                        {resultTrue && (
                            <motion.div
                                initial={{ opacity: 0, y: 12 }}
                                animate={{ opacity: 1, y: 0 }}
                                exit={{ opacity: 0, y: 12 }}
                                transition={{ duration: 0.22 }}
                                style={{
                                    marginTop: '22px',
                                    borderRadius: '18px',
                                    padding: '16px 18px',
                                    background: '#f3fff7',
                                    border: '1px solid rgba(25, 135, 84, 0.15)',
                                    color: '#146c43',
                                    fontWeight: 600,
                                }}
                            >
                                {resultTrue}
                            </motion.div>
                        )}
                    </AnimatePresence>
                </form>
            </div>
        </section>
    );
}

export default FornecedorForm;